import { useState } from "react";
import { InlineNotification } from "../components/InlineNotification";
import { useAuth } from "./AuthProvider";
import { LoginWidget } from "./LoginWidget";
import { SignupWidget } from "./SignupWidget";
import { EmailVerifyWidget } from "./EmailVerifyWidget";
import { AuthNavbar } from "../layout/AuthNavbar";

export const AuthWidget = () => {
  //
  const { user } = useAuth();
  const [showSignup, setShowSignup] = useState(false);

  const renderSignup = () => {
    return (
      <>
        <AuthNavbar showUserIcon={false}/>
        <div className="auth-widget">
          <SignupWidget onChange={() => setShowSignup(false)} />
        </div>
      </>
    );
  };

  const renderLogin = () => {
    return (
      <>
        <AuthNavbar showUserIcon={false}/>
        <div className="auth-widget">
          <LoginWidget onChange={() => setShowSignup(true)} />
        </div>
      </>
    );
  };

  // user not logged in
  if (!user) {
    if (showSignup) return renderSignup();
    return renderLogin();
  }

  // user present
  if (user.email && !user.emailVerified)
    return (
      <>
        <AuthNavbar showUserIcon={true}/>
        <div className="auth-widget">
          <EmailVerifyWidget email={user.email} />
        </div>
      </>
    );

  return (
    <InlineNotification message={`User already logged-in. Not ${user.email}, logout, to login as a different user.`} />
  );
};
